"use strict";

var _defineProperty = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _exports$SubtypeCodeT, _exports$TrAssetCateg, _exports$AssetSubtype, _exports$TrToAtomAsse;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtomAssetSubtypeCodes = exports.AtomAssetTypes = exports.TrToAtomAssetSubtypeCode = exports.AssetSubtypeCodeToTrAssetCode = exports.TrAssetCategoryToAssetType = exports.RefinitivToIexAssetCategory = exports.AssetCategory = exports.SubtypeCodeToAssetType = exports.AssetTypeToSubtypeCode = exports.AtomAssetSubtypeCode = exports.AtomAssetSubtype = exports.AtomAssetType = exports.EventTypes = exports.DocumentType = exports.Languages = exports.CountryCode = exports.EntityCategory = exports.TransactionType = exports.PortfolioAssetType = exports.AssetTypes = exports.ListingType = exports.MICToTrExchangeCode = exports.MICToMarket = exports.MarketToMics = exports.MICs = exports.TrExchangeCodeToMarket = exports.MarketToTrExchangeCode = exports.Markets = exports.TrExchangeCode = exports.IdentifierTypes = void 0;
exports.IdentifierTypes = ['ticker', 'atomAssetId', 'figi', 'isin', 'cusip'];
var TrExchangeCode;
(function (TrExchangeCode) {
  TrExchangeCode["bzx"] = "BZX";
  TrExchangeCode["tor"] = "TOR";
  TrExchangeCode["pnk"] = "PNK";
  TrExchangeCode["sao"] = "SAO";
  TrExchangeCode["crypto"] = "ATOM_CRYPTO";
})(TrExchangeCode || (exports.TrExchangeCode = TrExchangeCode = {}));
exports.Markets = ['USA', 'CAN', 'OTC', 'BRA', 'CRYPTO'];
exports.MarketToTrExchangeCode = {
  USA: TrExchangeCode.bzx,
  CAN: TrExchangeCode.tor,
  OTC: TrExchangeCode.pnk,
  BRA: TrExchangeCode.sao,
  CRYPTO: TrExchangeCode.crypto
};
exports.TrExchangeCodeToMarket = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, TrExchangeCode.bzx, 'USA'), TrExchangeCode.tor, 'CAN'), TrExchangeCode.pnk, 'OTC'), TrExchangeCode.sao, 'BRA'), TrExchangeCode.crypto, TrExchangeCode.crypto);
exports.MICs = ['BATS', 'XNAS', 'XNYS', 'ARCX', 'XASE', 'OTCB'];
exports.MarketToMics = {
  USA: ['BATS', 'XNAS', 'XNYS', 'ARCX', 'XASE'],
  OTC: ['OTCB'],
  BRA: [],
  CAN: [],
  CRYPTO: []
};
exports.MICToMarket = {
  BATS: 'USA',
  XNAS: 'USA',
  XNYS: 'USA',
  ARCX: 'USA',
  XASE: 'USA',
  OTCB: 'OTC'
};
exports.MICToTrExchangeCode = {
  // US
  BATS: TrExchangeCode.bzx,
  XNAS: TrExchangeCode.bzx,
  XNYS: TrExchangeCode.bzx,
  ARCX: TrExchangeCode.bzx,
  XASE: TrExchangeCode.bzx,
  // OTC
  OTCB: TrExchangeCode.pnk
};
var ListingType;
(function (ListingType) {
  ListingType["IPO"] = "IPO";
  ListingType["Listed"] = "Listed";
  ListingType["Delisted"] = "Delisted";
})(ListingType || (exports.ListingType = ListingType = {}));
exports.AssetTypes = ['equity', 'fund', 'crypto', 'index'];
var PortfolioAssetType;
(function (PortfolioAssetType) {
  PortfolioAssetType["EQUITY"] = "equity";
  PortfolioAssetType["FUND"] = "fund";
  PortfolioAssetType["CRYPTO"] = "crypto";
  PortfolioAssetType["CASH"] = "cash";
})(PortfolioAssetType || (exports.PortfolioAssetType = PortfolioAssetType = {}));
var TransactionType;
(function (TransactionType) {
  TransactionType["BUY"] = "buy";
  TransactionType["SELL"] = "sell";
  TransactionType["DEPOSIT"] = "deposit";
  TransactionType["WITHDRAWAL"] = "withdrawal";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var EntityCategory;
(function (EntityCategory) {
  EntityCategory["etf"] = "ETF";
  EntityCategory["symbol"] = "SYMBOL";
  EntityCategory["sector"] = "SECTOR";
  EntityCategory["investor"] = "INVESTOR";
  EntityCategory["mutual_fund"] = "MUTUAL_FUND";
  EntityCategory["fii"] = "FII";
  EntityCategory["bdr"] = "BDR";
  EntityCategory["crypto_category"] = "CRYPTO_CATEGORY";
})(EntityCategory || (exports.EntityCategory = EntityCategory = {}));
var CountryCode;
(function (CountryCode) {
  CountryCode["usa"] = "USA";
  CountryCode["bra"] = "BRA";
  CountryCode["can"] = "CAN";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
exports.Languages = ['en-US', 'pt-BR'];
var DocumentType;
(function (DocumentType) {
  DocumentType["EarningsTranscript"] = "EarningsTranscript";
  DocumentType["10-K"] = "10-K";
  DocumentType["10-Q"] = "10-Q";
  DocumentType["8-K"] = "8-K";
  DocumentType["Presentation"] = "Presentation";
  DocumentType["Other"] = "Other";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
exports.EventTypes = ['BrokerageAnalystCalls', 'BrokerageAnalystMeetings', 'CompanyVisits', 'ConferencePresentations', 'Conferences', 'CorporateAnalystMeetings', 'CorporateCallsAndPresentations', 'EarningsCallsAndPresentations', 'EarningsReleases', 'ExDividends', 'GeneralAndPoliticalEvents', 'GuidanceCallsAndPresentations', 'IpoFilings', 'IpoLockupExpirations', 'IpoPricings', 'MergerAndAcquisitionCallsAndPresentations', 'OtherCorporate', 'SalesAndTradingStatementCallsAndPresentations', 'SalesAndTradingStatementReleases', 'SecondaryFilings', 'SecondaryPricings', 'SecondaryWithdrawals', 'ShareholderAndAnnualMeetings', 'StockSplits', 'SyndicateRoadshows'];
//from table https://www.notion.so/atomfinance/Data-Standardization-421fc45f0ddc49309ae5d556fb2b57d9
var AtomAssetType;
(function (AtomAssetType) {
  AtomAssetType["equity"] = "Equity";
  AtomAssetType["crypto"] = "Crypto";
  AtomAssetType["fund"] = "Fund";
  AtomAssetType["index"] = "Index";
  //later:
  //fixedIncome = 'Fixed Income',
  //realEstate = 'Real Estate',
  //cash = 'Cash',
  //derivatives = 'Derivatives',
  //currencies = 'Currencies',
  //commodities = 'commodities',
})(AtomAssetType || (exports.AtomAssetType = AtomAssetType = {}));
var AtomAssetSubtype;
(function (AtomAssetSubtype) {
  AtomAssetSubtype["COMMON"] = "Common Stock";
  AtomAssetSubtype["PREFERRED"] = "Preferred Stock";
  AtomAssetSubtype["RIGHTS"] = "Rights";
  AtomAssetSubtype["UNITS"] = "Units";
  AtomAssetSubtype["ADR"] = "American Depository Receipt";
  AtomAssetSubtype["BDR"] = "Brazilian Depository Receipt";
  AtomAssetSubtype["CEF"] = "Closed-End Fund";
  AtomAssetSubtype["OEF"] = "Open-End Fund";
  AtomAssetSubtype["WARRANTS"] = "Warrants";
  AtomAssetSubtype["ETF"] = "Exchange Traded Fund";
  AtomAssetSubtype["MF"] = "Mutual Fund";
  AtomAssetSubtype["CONVERT"] = "Convertible";
  AtomAssetSubtype["CRY"] = "Cryptocurrencies";
  AtomAssetSubtype["REIT"] = "Real Estate Investment Trust";
  AtomAssetSubtype["PAR"] = "Equity - Participation";
  AtomAssetSubtype["INDEX"] = "Index";
  //later
  //RE = "Real Estate",
  //LOAN = "Loans",
})(AtomAssetSubtype || (exports.AtomAssetSubtype = AtomAssetSubtype = {}));
var AtomAssetSubtypeCode;
(function (AtomAssetSubtypeCode) {
  AtomAssetSubtypeCode["COMMON"] = "COMMON";
  AtomAssetSubtypeCode["PREFERRED"] = "PREFERRED";
  AtomAssetSubtypeCode["RIGHTS"] = "RIGHTS";
  AtomAssetSubtypeCode["UNITS"] = "UNITS";
  AtomAssetSubtypeCode["ADR"] = "ADR";
  AtomAssetSubtypeCode["BDR"] = "BDR";
  AtomAssetSubtypeCode["CEF"] = "CEF";
  AtomAssetSubtypeCode["OEF"] = "OEF";
  AtomAssetSubtypeCode["WARRANTS"] = "WARRANTS";
  AtomAssetSubtypeCode["ETF"] = "ETF";
  AtomAssetSubtypeCode["MF"] = "MF";
  AtomAssetSubtypeCode["CONVERT"] = "CONVERT";
  AtomAssetSubtypeCode["CRY"] = "CRY";
  AtomAssetSubtypeCode["REIT"] = "REIT";
  AtomAssetSubtypeCode["PAR"] = "PAR";
  AtomAssetSubtypeCode["INDEX"] = "INDEX";
})(AtomAssetSubtypeCode || (exports.AtomAssetSubtypeCode = AtomAssetSubtypeCode = {}));
exports.AssetTypeToSubtypeCode = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AtomAssetType.equity, [AtomAssetSubtypeCode.COMMON, AtomAssetSubtypeCode.PAR, AtomAssetSubtypeCode.CONVERT, AtomAssetSubtypeCode.PREFERRED, AtomAssetSubtypeCode.RIGHTS, AtomAssetSubtypeCode.UNITS, AtomAssetSubtypeCode.ADR, AtomAssetSubtypeCode.BDR, AtomAssetSubtypeCode.WARRANTS, AtomAssetSubtypeCode.REIT, AtomAssetSubtypeCode.OEF, AtomAssetSubtypeCode.CEF]), AtomAssetType.fund, [AtomAssetSubtypeCode.ETF, AtomAssetSubtypeCode.MF]), AtomAssetType.crypto, [AtomAssetSubtypeCode.CRY]), AtomAssetType.index, [AtomAssetSubtypeCode.INDEX]);
exports.SubtypeCodeToAssetType = (_exports$SubtypeCodeT = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$SubtypeCodeT, AtomAssetSubtypeCode.COMMON, AtomAssetType.equity), AtomAssetSubtypeCode.PREFERRED, AtomAssetType.equity), AtomAssetSubtypeCode.RIGHTS, AtomAssetType.equity), AtomAssetSubtypeCode.UNITS, AtomAssetType.equity), AtomAssetSubtypeCode.ADR, AtomAssetType.equity), AtomAssetSubtypeCode.BDR, AtomAssetType.equity), AtomAssetSubtypeCode.WARRANTS, AtomAssetType.equity), AtomAssetSubtypeCode.PAR, AtomAssetType.equity), AtomAssetSubtypeCode.CONVERT, AtomAssetType.equity), AtomAssetSubtypeCode.CEF, AtomAssetType.equity), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$SubtypeCodeT, AtomAssetSubtypeCode.OEF, AtomAssetType.equity), AtomAssetSubtypeCode.ETF, AtomAssetType.fund), AtomAssetSubtypeCode.MF, AtomAssetType.fund), AtomAssetSubtypeCode.CRY, AtomAssetType.crypto), AtomAssetSubtypeCode.REIT, AtomAssetType.equity), AtomAssetSubtypeCode.INDEX, AtomAssetType.index));
var AssetCategory;
(function (AssetCategory) {
  AssetCategory["ORD"] = "ORD";
  AssetCategory["DRC"] = "DRC";
  AssetCategory["UNT"] = "UNT";
  AssetCategory["PRF"] = "PRF";
  AssetCategory["CPR"] = "CPR";
  AssetCategory["RTS"] = "RTS";
  AssetCategory["EIW"] = "EIW";
  AssetCategory["ECL"] = "ECL";
  AssetCategory["ETF"] = "ETF";
  AssetCategory["BDR"] = "BDR";
  AssetCategory["FII"] = "FII";
  AssetCategory["PAR"] = "PAR";
  AssetCategory["OPF"] = "OPF";
  AssetCategory["EQI"] = "EQI";
  AssetCategory["CRYPTO"] = "ATOM_CRYPTO";
  AssetCategory["MF"] = "ATOM_MF";
})(AssetCategory || (exports.AssetCategory = AssetCategory = {}));
var RefinitivToIexAssetCategory;
(function (RefinitivToIexAssetCategory) {
  RefinitivToIexAssetCategory["ORD"] = "cs";
  RefinitivToIexAssetCategory["UNT"] = "ut";
  RefinitivToIexAssetCategory["PRF"] = "ps";
  RefinitivToIexAssetCategory["RTS"] = "rt";
  RefinitivToIexAssetCategory["EIW"] = "wt";
  RefinitivToIexAssetCategory["ETF"] = "et";
})(RefinitivToIexAssetCategory || (exports.RefinitivToIexAssetCategory = RefinitivToIexAssetCategory = {}));
exports.TrAssetCategoryToAssetType = (_exports$TrAssetCateg = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$TrAssetCateg, AssetCategory.ORD, 'equity'), AssetCategory.DRC, 'equity'), AssetCategory.UNT, 'equity'), AssetCategory.PRF, 'equity'), AssetCategory.RTS, 'equity'), AssetCategory.CPR, 'equity'), AssetCategory.EIW, 'equity'), AssetCategory.ECL, 'equity'), AssetCategory.OPF, 'equity'), AssetCategory.PAR, 'equity'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$TrAssetCateg, AssetCategory.BDR, 'equity'), AssetCategory.FII, 'equity'), AssetCategory.ETF, 'fund'), AssetCategory.MF, 'fund'), AssetCategory.CRYPTO, 'crypto'), AssetCategory.EQI, 'index'));
exports.AssetSubtypeCodeToTrAssetCode = (_exports$AssetSubtype = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$AssetSubtype, AtomAssetSubtypeCode.COMMON, AssetCategory.ORD), AtomAssetSubtypeCode.PREFERRED, AssetCategory.PRF), AtomAssetSubtypeCode.RIGHTS, AssetCategory.RTS), AtomAssetSubtypeCode.UNITS, AssetCategory.UNT), AtomAssetSubtypeCode.ADR, AssetCategory.DRC), AtomAssetSubtypeCode.BDR, AssetCategory.BDR), AtomAssetSubtypeCode.CEF, AssetCategory.ECL), AtomAssetSubtypeCode.OEF, AssetCategory.OPF), AtomAssetSubtypeCode.WARRANTS, AssetCategory.EIW), AtomAssetSubtypeCode.ETF, AssetCategory.ETF), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$AssetSubtype, AtomAssetSubtypeCode.CONVERT, AssetCategory.CPR), AtomAssetSubtypeCode.CRY, AssetCategory.CRYPTO), AtomAssetSubtypeCode.REIT, AssetCategory.FII), AtomAssetSubtypeCode.PAR, AssetCategory.PAR), AtomAssetSubtypeCode.MF, AssetCategory.MF), AtomAssetSubtypeCode.INDEX, AssetCategory.EQI));
exports.TrToAtomAssetSubtypeCode = (_exports$TrToAtomAsse = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$TrToAtomAsse, AssetCategory.ORD, AtomAssetSubtypeCode.COMMON), AssetCategory.PRF, AtomAssetSubtypeCode.PREFERRED), AssetCategory.RTS, AtomAssetSubtypeCode.RIGHTS), AssetCategory.UNT, AtomAssetSubtypeCode.UNITS), AssetCategory.DRC, AtomAssetSubtypeCode.ADR), AssetCategory.BDR, AtomAssetSubtypeCode.BDR), AssetCategory.ECL, AtomAssetSubtypeCode.CEF), AssetCategory.OPF, AtomAssetSubtypeCode.OEF), AssetCategory.EIW, AtomAssetSubtypeCode.WARRANTS), AssetCategory.ETF, AtomAssetSubtypeCode.ETF), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_exports$TrToAtomAsse, AssetCategory.CPR, AtomAssetSubtypeCode.CONVERT), AssetCategory.FII, AtomAssetSubtypeCode.REIT), AssetCategory.PAR, AtomAssetSubtypeCode.PAR), AssetCategory.CRYPTO, AtomAssetSubtypeCode.CRY), AssetCategory.MF, AtomAssetSubtypeCode.MF), AssetCategory.EQI, AtomAssetSubtypeCode.INDEX));
exports.AtomAssetTypes = Object.values(AtomAssetType);
exports.AtomAssetSubtypeCodes = Object.values(AtomAssetSubtypeCode);